<template>
    <TabView :scrollable="true">
        <TabPanel v-for="visita in visitas" :key="visita"
            :header="new Date(visita.visita.fecha).toLocaleDateString() + ' ' + visita.visita.hora.slice(0, -3) + ' - ' + visita.visita.nombre_operario">
            <div class="row">
                <div class="col-sm-4" v-for="archivos in visita.archivos" :key="archivos">
                    <!---->
                    <div
                        v-if="archivos.documento.substr(archivos.documento.length - 3) == 'jpg' || archivos.documento.substr(archivos.documento.length - 3) == 'png' || archivos.documento.substr(archivos.documento.length - 4) == 'jpeg' || archivos.documento.substr(archivos.documento.length - 3) == 'bmp' || archivos.documento.substr(archivos.documento.length - 3) == 'gif' || archivos.documento.substr(archivos.documento.length - 4) == 'tiff' || archivos.documento.substr(archivos.documento.length - 4) == 'webp'">
                        <Image v-if="urlglobal != 'null.pwgs.app'" :src='archivos.url_completa_descarga'
                            :id="archivos.id_documento" width="150" height="150" preview :alt="archivos.descripcion" />
                        <Image v-if="urlglobal == 'null.pwgs.app'"
                            :src='"https://desarrollofront.pwgs.app/documentos.php?documento=" + archivos.documento + "&servicio=" +id '
                            :id="archivos.id_documento" width="150" height="150" preview :alt="archivos.descripcion" />
                        <div v-if="archivos.cuando" style="text-align: center;">
                            <span style="margin-right: 5px;" v-if="archivos.cuando=='despues'"
                                class="badge bg-blue">después</span>
                            <span style="margin-right: 5px;" v-else class="badge bg-blue">{{archivos.cuando}}</span>
                        </div>
                    </div>
                    <div :title="archivos.documento" class="row">
                        <div class="col-md-1">
                            <input :id="archivos.id_documento" @change="marcar(archivos)" v-model="archivos.checked"
                                type="checkbox">
                        </div>
                        <div class="col-md-10">
                            <label v-if="archivos.documento.valueOf().length>15" :for="archivos.id_documento">
                                {{ archivos.documento.substring(0,15)+'...' }} </label>
                            <label v-if="archivos.documento.valueOf().length <= 15" :for="archivos.id_documento">
                                {{ archivos.documento}} </label>
                        </div>
                    </div>
                </div>
            </div>
        </TabPanel>
    </TabView>
</template>
<script>
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Image from 'primevue/image';
import { PwgsApi } from '../../../../../services/PwgsApi';

export default ({
    props: ['id'],

    data() {
        return {
            todos: false,
            visitas: [],
            marcados: [],
        }
    },
    components: {
        TabPanel, TabView, Image
    },
    methods: {
        marcar(archivo) {
            if (archivo.checked) {
                this.marcados.push(archivo.documento);
            } else {
                this.marcados = this.marcados.filter(doc => doc != archivo.documento);
            }
            console.log("parent", this.$parent.$parent.$parent);
            this.$parent.$parent.$parent.anyadirfotos(this.marcados);
        },
        
        async cargardatos() {
            const api = new PwgsApi();
            this.visitas = await api.get('servicios/' + this.id + '/visitas');
        },
       
    },
    mounted() {
        this.cargardatos();
    },
    watch: {
        


    }
})

</script>
